import { RRule } from 'rrule';
import { weekRRulelist, weekRRuleOfMonths } from '../eventService/eventApiService';
import moment from 'moment';
export const rRuleFrame = (rruleOption: any, mode: string, startDate: Date, endDate: Date) => {
  let sDate: any = (moment(startDate).toDate());
  let eDate:any=(moment(endDate).toDate());
     var interval = 30 * 60 * 1000;
  let sDateRoundOff: any = new Date(Math.ceil(sDate.getTime() / interval) * interval)
   let  eDateRoundOff:any=new Date(Math.ceil(eDate.getTime() / interval) * interval)
  let freq_recurrence = mode === "Weekly"?RRule.WEEKLY:mode === "Monthly"?
    RRule.MONTHLY : RRule.DAILY;
  let weeklyOccuron: any = [];
  if(mode === "Weekly"){
    rruleOption?.weeklyOccuron.map((data: any) => {
      let reculist = weekRRulelist(data);
      weeklyOccuron.push(reculist);
    });
  }
  if(mode === "Monthly" && !rruleOption.monthlyOccureon){
    let reculist = weekRRuleOfMonths(rruleOption.monthlyDay,rruleOption.monthlyWeek);
    weeklyOccuron.push(reculist);
  }

  const rruleObject:any = {
    freq: freq_recurrence,
    dtstart: sDateRoundOff,
    until: eDateRoundOff,
    byweekday: weeklyOccuron,
    interval: rruleOption.repeat_every,
    //count: (!rruleOption.value_disabled) ? rruleOption.afteroccur : 0,
    bymonthday:(mode === "Monthly" && rruleOption.monthlyOccureon) ? [rruleOption.occurOnDay] : 0
  };

  // const rruleObject:any =
  // {
  //   freq: freq_recurrence,
  //   //dtstart: new Date(startDate),
  //   //until: new Date(endDate),
  //   byweekday: weeklyOccuron,
  //   count: (!rruleOption.value_disabled) ? rruleOption.afteroccur : 0
  // };



  return new RRule(rruleObject);;
  
};

export const getEndDate = (key: string, count: number, sDate:Date) => {
  let setDefaultDate = new Date(sDate);
  let endDate = new Date();
  if (key === 'Monthly') {
    endDate = new Date(setDefaultDate.setMonth(setDefaultDate.getMonth() +
    (6 * count)));
  }
  else {
    let getTotoalCount = key === "Daily" ? 6 : 42;
    endDate = new Date(setDefaultDate.setDate(setDefaultDate.getDate() +
    (getTotoalCount * count)));
  }
  return endDate;
};